<section
  class="tree-root uls"
  [attr.aria-label]="'requirementIntake.tree.aria.requirementNavigation' | translate"
>
  @if (hasError()) {
    <p class="tree-message tree-message-error">
      {{ 'requirementIntake.tree.loadError' | translate }}
    </p>
  } @else if (isLoading()) {
    <p class="tree-message">{{ 'requirementIntake.tree.loading' | translate }}</p>
    <mat-spinner></mat-spinner>
  } @else if (isEmpty()) {
    <p class="tree-message">{{ 'requirementIntake.tree.empty' | translate }}</p>
  } @else {
    @for (group of groups(); track group.category) {
      <article class="tree-group ul-card" #categoryElement [attr.data-category]="group.category">
        <button
          type="button"
          class="group-toggle"
          [class.group-toggle-expanded]="isExpanded(group.category)"
          (click)="toggleCategory(group.category)"
        >
          <div class="group-index" [class.active]="hasSelectedItem(group.category)">
            {{ group.categoryNumber }}
          </div>
          <span class="group-title">{{ group.category }}</span>
          <span class="group-meta">
            <span
              class="group-count"
              [matTooltip]="
                (hasItemWithReviewFindings(group.category)
                  ? 'requirementIntake.tree.decidedCountWithFindingsTooltip'
                  : 'requirementIntake.tree.decidedCountTooltip'
                ) | translate: { decided: group.decidedCount, total: group.requirements.length }
              "
              matTooltipClass="group-count-tooltip"
              matTooltipPosition="above"
            >
              @if (hasItemWithReviewFindings(group.category)) {
                <span class="verdict-indicator-fail">!</span>
              }
              {{ group.decidedCount }} / {{ group.requirements.length }}
            </span>
            <svg class="group-chevron" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path
                d="M6 9l6 6 6-6"
                stroke="currentColor"
                fill="none"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </button>

        <div class="requirement-list-wrapper" [class.expanded]="isExpanded(group.category)">
          <div class="requirements-list-inner">
            <ul class="requirement-list">
              @for (requirement of group.requirements; track requirement.id) {
                <li>
                  <button
                    type="button"
                    class="requirement-item"
                    [class.requirement-item-selected]="isSelected(requirement.id)"
                    (click)="openRequirement(requirement.id)"
                  >
                    <span class="requirement-main">
                      <span class="requirement-name">{{ requirement.name }}</span>
                      <span class="evidence-count">
                        {{
                          'requirementIntake.tree.evidenceCount'
                            | translate: { count: requirement.evidenceCount }
                        }}
                      </span>
                    </span>
                    <span class="requirement-status">
                      @if (
                        requirement.status === 'DECIDED' && requirement.verdictResult;
                        as verdictResult
                      ) {
                        <span
                          class="verdict-indicator"
                          [class.verdict-indicator-pass]="verdictResult === 'PASS'"
                          [class.verdict-indicator-fail]="verdictResult === 'FAIL'"
                        >
                          {{ resultLabelKey(verdictResult) | translate }}
                        </span>
                      } @else {
                        <comp-intake-state-pill
                          [status]="requirement.status"
                          [size]="'compact'"
                        ></comp-intake-state-pill>
                      }
                    </span>
                    <!-- <div class="selection-indicator"></div>-->
                  </button>
                </li>
              }
            </ul>
          </div>
        </div>
      </article>
    }
  }
</section>
